export default [
  {
    path: '/scouting-report',
    component: () => import('@/views/scouting-report/index.vue'),
    meta: {
      title: '球探报告列表',
    },
  },
  {
    path: '/scouting-report-details',
    component: () => import('@/views/scouting-report/details.vue'),
    meta: {
      title: '球探报告详情',
    },
  },
];
